import { defineMessages } from 'react-intl-next';

export const i18n: {
	appTooltipFor1Pand3PApps: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tooltipForAllApps: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	appTooltipFor1Pand3PApps: {
		id: 'inline-app-selector.1p-3p-app-tooltip',
		defaultMessage: 'Open a full page search for this term filtered by {productName} results',
		description: 'Tooltip for 1P/3P App',
	},
	tooltipForAllApps: {
		id: 'inline-app-selector.all-apps-tooltip',
		defaultMessage: 'Open a full page search for this term searching all apps',
		description: 'Tooltip for All Apps',
	},
});
